import { render, staticRenderFns } from "./ConfigAlertSubjectBody.vue?vue&type=template&id=03e2f996&scoped=true&"
import script from "./ConfigAlertSubjectBody.vue?vue&type=script&lang=js&"
export * from "./ConfigAlertSubjectBody.vue?vue&type=script&lang=js&"
import style0 from "./ConfigAlertSubjectBody.vue?vue&type=style&index=0&id=03e2f996&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03e2f996",
  null
  
)

export default component.exports